"use client"
import { ThemeProvider as NextThemesProvider, type ThemeProviderProps } from "next-themes"

export default function ThemeProvider({ children, ...props }: ThemeProviderProps) {
  return (
    <NextThemesProvider
      attribute="data-theme"
      defaultTheme="nature"
      enableSystem={false}
      storageKey="app-theme"
      {...props}
    >
      {children}
    </NextThemesProvider>
  )
}
